module.exports = __webpack_public_path__ + "static/img/icon_news.2ace6a56.svg";